import { BitfDefaultResponseMapper } from '@bitf/core/parsers/default-parser';

export class AppResponseMapper extends BitfDefaultResponseMapper {}
